document.addEventListener("DOMContentLoaded", function() {
  // --- Remove Loox review brackets ---
  function removeLooxBrackets() {
    const reviewContainer = document.querySelector('.satcb_reviews_stars');
    if (reviewContainer && !reviewContainer.dataset.looxFormatted) {
      const looxWidget = reviewContainer.querySelector('.loox-rating.loox-widget');
      const ratingLabel = reviewContainer.querySelector('.loox-rating-label');
      if (looxWidget && ratingLabel) {
        const rating = looxWidget.getAttribute('data-rating');
        if (rating) {
          reviewContainer.style.visibility = 'hidden';
          ratingLabel.innerHTML = `&nbsp;${rating}`;
          reviewContainer.style.visibility = 'visible';
          reviewContainer.dataset.looxFormatted = 'true';
        }
      }
    }
  }

  // --- Currency setup ---
  const removableSuffixes   = ['AUD','CAD','NZD','EUR','GBP','USD'];
  const suffixToPrefixMap   = { AUD:'A$', CAD:'C$', NZD:'NZ$', USD:'$', EUR:'€', GBP:'£' };
  const containersSelector = [
    '.price__current', '.satcb_price', '.satcb_was_price', '.cart-item--sale-price',
    '.atc-subtotal--price', '.atc--product-details--price-value',
    '.cart-item--content-price', '.cart-item__total',
    '.cart-subtotal', '.atc-banner--cart-subtotal',
    '.cart-title-total--small',
    '.cart-complementary__price-row',
    '.options-selection__swatch-card-price',
    '.savings',
    '.voucher-amount',
    '.complementary-product__price'
  ].join(',');

  // This function takes raw text and returns formatted HTML
  function getFormattedPriceHTML(rawText) {
    let cleaned = rawText;
    let overrideCur = null;
    const sufMatch = cleaned.match(/([\d.,]+)\s*([A-Z]{3})$/);
    if (sufMatch && removableSuffixes.includes(sufMatch[2])) {
      cleaned = cleaned.replace(/\s*[A-Z]{3}$/,'');
      overrideCur = suffixToPrefixMap[sufMatch[2]];
    }

    const symMatch = cleaned.match(/^(C\$|NZ\$|A\$|\$|€|£)/);
    let symbol = overrideCur || (symMatch ? symMatch[1] : '$');
    if (symbol === 'NZ$') symbol = '$';
    let numPart = cleaned.replace(/^(C\$|NZ\$|A\$|\$|€|£)/,'').trim();
    const numTokens = numPart.match(/(?:\d{1,3}(?:[., ]\d{3})+|\d+)(?:[.,]\d{1,2})?/g);
    if (numTokens && numTokens.length) numPart = numTokens[numTokens.length - 1];
    numPart = numPart.replace(/\s/g, '');
    const commaAsDec = numPart.lastIndexOf(',') === numPart.length - 3;
    if (commaAsDec) {
      numPart = numPart.replace(/\./g,'').replace(',','.');
    } else {
      numPart = numPart.replace(/,/g,'');
    }

    const m = numPart.match(/^(\d+)\.(\d{2})$/);
    if (!m) return null; // Return null if format is not recognized
    const [ , whole, frac ] = m;

    let symbolHTML;
    if (['C$', 'A$', 'NZ$'].includes(symbol)) {
      const letter = symbol.slice(0, -1);
      const dollar = symbol.slice(-1);
      symbolHTML = `<span style="font-size: .7em !important; vertical-align: top !important; position: relative !important; top: 2px !important; padding-right: 2px !important;">${letter}</span><span>${dollar}</span>`;
    } else {
      symbolHTML = symbol;
    }

    return `<div class="satcb_price_inner">` +
           `<span class="price-symbol">${symbolHTML}</span>` +
           `<span class="price-whole">${whole}</span>` +
           `<span class="price-fraction">${frac}</span>` +
           `</div>`;
  }

  function formatPrices() {
    document.querySelectorAll(containersSelector).forEach(container => {
      // Note: .satcb_price / .satcb_was_price used to be delegated to handleSatcbPrice()
      // via a sibling-display hack, but newer SATCB layouts put the .money class on the
      // .satcb_price container itself (no nested .money child), which broke that handler.
      // Format here directly — the self-healing .price-symbol check on every observer
      // tick reformats if SATCB ever overwrites the contents (e.g. on variant change).
      let els = container.querySelectorAll('.money');
      if (!els.length && (container.classList.contains('money') || container.classList.contains('savings') || container.classList.contains('voucher-amount'))) els = [container];

      els.forEach(el => {
        // Trust the DOM, not a dataset flag — see UK ratings-replace.js for the full
        // rationale. Self-heals if any other script (currency switcher, app price updater,
        // cart drawer rerender) clobbers our .money innerHTML back to raw text.
        if (el.querySelector('.price-symbol')) return;
        const formattedHTML = getFormattedPriceHTML(el.textContent.trim());
        if (formattedHTML) {
          el.innerHTML = formattedHTML;
        }
      });
    });
  }

  function handleSatcbPrice() {
    const satcbPriceContainer = document.querySelector('.satcb_price, .satcb_was_price');
    if (!satcbPriceContainer) return;

    const originalPriceEl = satcbPriceContainer.querySelector('.money');
    if (!originalPriceEl) return;

    // Find or create our custom display element
    let customDisplay = satcbPriceContainer.querySelector('.custom-formatted-price');
    if (!customDisplay) {
      customDisplay = document.createElement('div');
      customDisplay.className = 'custom-formatted-price';
      originalPriceEl.parentNode.insertBefore(customDisplay, originalPriceEl.nextSibling);
      
      // Hide the original element permanently
      originalPriceEl.style.display = 'none';
    }

    const rawText = originalPriceEl.textContent.trim();
    const formattedHTML = getFormattedPriceHTML(rawText);
    
    // Update our custom element, leaving the original hidden one alone
    if (formattedHTML && customDisplay.innerHTML !== formattedHTML) {
      customDisplay.innerHTML = formattedHTML;
    }
  }

  function stripNZ() {
    var els = document.querySelectorAll('.money');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.childElementCount > 0) continue;
      var t = el.textContent;
      if (t.indexOf('NZ$') !== -1) el.textContent = t.replace(/NZ\$/g, '$');
    }
  }

  // --- Observer to handle dynamic SATCB price changes ---
  const observer = new MutationObserver((mutations) => {
    // We only care about changes inside the SATCB price element
    for (const mutation of mutations) {
      if (mutation.target.closest('.satcb_price, .satcb_was_price')) {
        handleSatcbPrice();
        break; // Handle it once and exit
      }
    }
    // Also run the normal price formatter for other elements that might have changed
    formatPrices();
    stripNZ();
    removeLooxBrackets();
  });

  // --- Initial run and start observing ---

  removeLooxBrackets();
  formatPrices();
  stripNZ();
  handleSatcbPrice(); // Initial setup for the SATCB bar

  observer.observe(document.body, { 
    childList: true, 
    subtree: true,
    characterData: true // Important for detecting text changes
  });
});

